import { FunctionComponent, useState } from 'react';
import { Typography } from '@mui/material';

import { TitleBox, TitleText, ServicesCard } from '../styled';
import { StyledDivider } from '../../../styled';
import GitHubService from './GitHub';
import Loader from '../../../../shared/LoaderLinear';

const IntegrationService: FunctionComponent = () => {
    const [loading, setLoading] = useState(false);

    return (
        <ServicesCard>
            {loading && <Loader />}
            <TitleBox>
                <Typography variant="body1" color="white" component={TitleText}>
                    Choose services to connect
                </Typography>
            </TitleBox>
            <StyledDivider />
            <GitHubService setLoading={setLoading} />
        </ServicesCard>
    );
};

export default IntegrationService;
